import React, { PureComponent } from 'react';
import { ProductCompliance } from '~/Api/CzSuklCompliance';
import InfoText, { Type as InfoTextType } from '~/UI/InfoText/InfoText';

interface Props {
	compliance: ProductCompliance;
}

export default class ComplianceInfo extends PureComponent<Props> {
	render() {
		const { compliance } = this.props;
		const ruleDescription = compliance.resolveRuleDescription();

		if (!ruleDescription) {
			return null;
		}
		if (compliance.isAccept) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.note}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		if (compliance.isAcceptNoRulesForDataSource) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.note}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		if (compliance.isAcceptBeforeValidity) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.warning}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		if (compliance.isCannotInterpretRules) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.warning}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		if (compliance.isReject) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.danger}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		if (compliance.isRejectNoPrices) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.danger}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		if (compliance.isRejectNotAReferenceDataSource) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.danger}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		if (compliance.isRejectRemoved) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.danger}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		if (compliance.isRejectAfterValidity) {
			return (
				<InfoText header={ruleDescription} type={InfoTextType.danger}>
					{compliance.decisionComment}
				</InfoText>
			);
		}
		return null;
	}
}
